import React from 'react'

export interface DetailField {
  label: string
  value?: React.ReactNode
  fullWidth?: boolean
  hidden?: boolean
}

export interface DetailFieldGridProps {
  fields: DetailField[]
  columns?: 2 | 3 | 4
  className?: string
}

export function DetailFieldGrid({ fields, columns = 3, className = '' }: DetailFieldGridProps) {
  const visible = fields.filter((f) => !f.hidden && f.value !== undefined && f.value !== null && f.value !== '')
  if (visible.length === 0) return null

  const colClass =
    columns === 4
      ? 'sm:grid-cols-2 lg:grid-cols-4'
      : columns === 2
        ? 'sm:grid-cols-2'
        : 'sm:grid-cols-2 lg:grid-cols-3'

  return (
    <div className={`grid grid-cols-1 ${colClass} gap-x-4 gap-y-3 ${className}`}>
      {visible.map((field) => (
        <div key={field.label} className={field.fullWidth ? 'sm:col-span-2 lg:col-span-3' : ''}>
          <p className="text-xs font-medium text-gray-500">{field.label}</p>
          <div className="text-sm text-gray-900 mt-0.5">{field.value}</div>
        </div>
      ))}
    </div>
  )
}
